import * as React from 'react'

export default function NotFound (props) {
  return (
    <>
			404 error
    </>
  )
}